import { render, staticRenderFns } from "./MeterialManagelist.vue?vue&type=template&id=38888338"
import script from "./MeterialManagelist.vue?vue&type=script&lang=js"
export * from "./MeterialManagelist.vue?vue&type=script&lang=js"
import style0 from "./MeterialManagelist.vue?vue&type=style&index=0&id=38888338&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports